import request from "../../../utils/request";
import { getbaseinfo } from "../../../service/detail";
import { resolveIntlAppCateIdFromSources } from "../../../utils/intlRegister";

const INTL_SOFTMGR_BASE = "main/intl/plat/v1/softmgr";

/** 国际 softmgr 请求统一带 is_international=1；禁止显式 0 */
const withIntlBody = (params = {}) => {
  const next = { ...params };
  next.is_international = 1;
  return next;
};

export const fetchIntlSoftLists = (params = {}) => {
  return request.post(`${INTL_SOFTMGR_BASE}/lists`, withIntlBody(params));
};

export const createIntlSoft = (params = {}) => {
  return request.post(`${INTL_SOFTMGR_BASE}/create`, withIntlBody(params));
};

export const fetchIntlSoftDetail = (id) => {
  return request.get(`${INTL_SOFTMGR_BASE}/getdetail`, { params: { id } });
};

/** 管理页详情：getbaseinfo（凭证/状态/回调）+ getdetail（地区/多语言/社交） */
export const fetchIntlSoftDetailMerged = async (id) => {
  const [base = {}, intl = {}] = await Promise.all([
    getbaseinfo({ id }).catch(() => ({})),
    fetchIntlSoftDetail(id).catch(() => ({})),
  ]);

  const appCateId = resolveIntlAppCateIdFromSources(base, intl);

  return {
    ...intl,
    ...base,
    app_id: base.app_id || intl.app_id,
    app_name: base.app_name || intl.app_name,
    app_version: base.app_version || intl.app_version,
    app_cate_id: appCateId,
    app_cate_d: appCateId,
    logo_url: base.logo_url || intl.logo_pic || intl.logo_url,
    callback_url: base.callback_url ?? intl.callback_url,
    channel: base.channel ?? intl.channel,
    app_status_id: base.app_status_id ?? intl.app_status_id,
    white_list_region: intl.white_list_region ?? base.white_list_region,
    soft_multi_language: intl.soft_multi_language ?? base.soft_multi_language,
    contact_x: intl.contact_x ?? base.contact_x,
    contact_telegram: intl.contact_telegram ?? base.contact_telegram,
    contact_discord: intl.contact_discord ?? base.contact_discord,
    app_email: intl.app_email || base.app_email,
    remark: base.remark ?? intl.remark,
  };
};

export const saveIntlSoftDetail = (params = {}) => {
  return request.post(`${INTL_SOFTMGR_BASE}/save`, withIntlBody(params));
};

export const fetchIntlRegionCodeList = () => {
  return request.get(`${INTL_SOFTMGR_BASE}/region_code_list`);
};

export function useIntlSoftApi() {
  return {
    fetchLists: fetchIntlSoftLists,
    createSoft: createIntlSoft,
    fetchDetail: fetchIntlSoftDetail,
    fetchDetailMerged: fetchIntlSoftDetailMerged,
    saveDetail: saveIntlSoftDetail,
    fetchRegionCodeList: fetchIntlRegionCodeList,
  };
}

export default useIntlSoftApi;
